// import { API_BASE_URL } from "configs/AppConfig";
import { Link } from "react-router-dom";

const Linkable = ({ children, data, className, link, isInternal = true, isSystem = true, id, ...reset }) => {
  return link !== null ? (
    isInternal ? (
      <Link 
        to={`${!isSystem ? `/servicestools/${id}` : `/${link}`}`} 
        className={className} 
        {...reset}
      >
        {children}
      </Link>
    ) : (
      <a href={link} target="_blank" rel="noreferrer" {...reset}>
        {children}
      </a>
    )
  ) : (
    <div className={className}></div>
  );
};

export default Linkable;
